<template>
  <div style="background: #f5f5f5;">
    <HeaderView :title="$t('mine.information')" />
    <div class="view-page">
      <div class="avatar-box">
        <van-image
          round
          width="4.2rem"
          height="4.2rem"
          :src="userInfo.header_img"
        />
        <p>{{ userInfo.username }}</p>
      </div>
      <div class="menu-box">
        <van-cell-group inset>
          <van-cell :title="$t('infomation.memberid')" :value="userInfo.username" />
          <van-cell :title="$t('infomation.fullname')" is-link :value="userInfo.name" to="/setname" />
          <van-cell :title="$t('infomation.bank')" is-link :value="isBank ? '' : $t('common.nodata')" to="/bank" />
          <van-cell :title="$t('infomation.phone')" is-link :value="userInfo.phone ? userInfo.phone : '-'" to="/setphone" />
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from "@/components/Header/index.vue";
export default {
  name: "InfomationView",
  components: { HeaderView },
  data() {
    return {
      isActive: false,
      show: false,
      isBank: false,
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    toSetName() {
      this.$router.push({ path: "/Setname" });
    },
    toSetBank() {
      this.$router.push({ path: "/Setbank" });
    },
    toSetSex() {
      this.$router.push({ path: "/Setsex" });
    },
    openHerderImg() {
      this.show = true;
    },
    select_header_img(url) {
      this.isActive = url;
    },
    check() {
      this.$http({
        method: "post",
        data: { header_img: this.isActive },
        url: "user_header_img",
      }).then((res) => {
        if (res.code === 200) {
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.isBank = true;
          } else {
            this.isBank = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  },
};
</script>
<style lang="scss" scoped>
.avatar-box {
  text-align: center;
  padding: 1.5rem 0 2rem;
  margin: 1rem 1rem 1.5rem;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 1rem;
  box-shadow: 0 4px 12px #667eea4d;
  p {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    margin-top: 15px;
  }
}
</style>
